import BasicInfo from 'pages/manage/agency/basic-info';
import Qualification from 'pages/manage/agency/qualification';
import Ability from 'pages/manage/agency/ability';
import Operator from 'pages/manage/agency/operator';
import Agreement from 'pages/manage/agency/agreement';
import ApplicationList from 'pages/manage/application/pages/list';
import ApplicationDetail from 'pages/manage/application/pages/detail';
// @ts-ignore
import OrderSquareList from 'pages/manage/orderSquare/pages/list/index.js';
import { useEffect, useState } from 'react';
import { useTypedSelector } from 'store/index';
// @ts-ignore
import { activeAccountType } from 'common/const';
import useAgencyDetail from './agency/use-agency-detail';
import { AgencyStatus } from 'model/agency';

const agency = [activeAccountType.isvAgency, activeAccountType.proxyAgency];

interface Menu {
  key: string;
  label: string;
  href?: string;
  component?: any;
  hide?: boolean;
  exact?: boolean;
  data?: Array<Menu>;
}

// 广告代理服务商可看到商机管理模块的角色
const ProxyAgencyCanViewOrderSquareActiveAccountRoleList: number[] = [100, 101];
// isv 服务商可看到商机管理模块的角色 暂时不做权限划分
// const IsvAgencyCanViewOrderSquareActiveAccountRoleList: number[] = [1, 10];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getMenus = (status: number, activeAccountRole: number) => {
  const list: Array<Menu> = [
    {
      key: 'manage-agency',
      label: '服务商管理',
      data: [
        {
          key: 'manage-agency-basic',
          label: '入驻管理',
          href: '/manage/agency/basic',
          component: BasicInfo,
        },
        {
          key: 'manage-agency-qualification',
          label: '资质管理',
          href: '/manage/agency/qualification',
          component: Qualification,
        },
        {
          key: 'manage-agency-ability',
          label: '能力管理',
          href: '/manage/agency/ability',
          component: Ability,
        },
        {
          key: 'manage-agency-operator',
          label: '成员管理',
          href: '/manage/agency/operator',
          component: Operator,
        },
        {
          key: 'manage-agency-agreement',
          label: '合作协议',
          href: '/manage/agency/agreement',
          component: Agreement,
        },
      ],
    },
    {
      key: 'manage-application',
      label: '应用管理',
      href: '/manage/application',
      component: ApplicationList,
      exact: true,
      data: [
        {
          key: 'manage-application',
          label: '应用详情',
          href: '/manage/application/operation/:type?/:id?/:name?',
          component: ApplicationDetail,
          hide: true,
        },
      ],
    },
  ];
  // 审批通过和储备可以看到商机管理
  if (status === AgencyStatus.pass || status === AgencyStatus.pause) {
    list.push({
      key: 'order-square',
      label: '商机管理',
      href: '/manage/order',
      component: OrderSquareList,
      exact: true,
    });
  }
  return list;
};

const getProxyAgencyMenus = (activeAccountRole: number) => {
  const proxyAgencyMenus: Array<Menu> = [];
  if (true || ProxyAgencyCanViewOrderSquareActiveAccountRoleList.includes(activeAccountRole)) {
    proxyAgencyMenus.push({
      key: 'order-square',
      label: '商机管理',
      href: '/manage/order',
      component: OrderSquareList,
      exact: true,
    });
  }
  return proxyAgencyMenus;
};

export const buildRoutes = (data: Array<Menu>) => {
  const routes: Array<Menu> = [];
  data.forEach((v) => {
    if (v.href && v.component) {
      routes.push(v);
    }
    v.data?.forEach((w) => {
      if (w.href && w.component) {
        routes.push(w);
      }
    });
  });
  return routes;
};

// export default {
//   menus,
//   routes: buildRoutes(menus),
// };

export default () => {
  const { user } = useTypedSelector((state) => state.user);
  const [routes, setRoutes] = useState<Array<Menu>>([]);
  const [menusList, setMenusList] = useState<Array<Menu>>([]);
  const agencyDetailProps: any = useAgencyDetail();

  // console.log('user', user);

  useEffect(() => {
    const canManageAgency = agency.includes(user?.active_account_type);
    if (!canManageAgency) {
      return;
    }
    if (user?.active_account_type === activeAccountType.proxyAgency) {
      // 广告代理的超级管理员和管理员可以看到/承接广告投放需求
      const menus = getProxyAgencyMenus(user?.active_account_role);
      setMenusList(menus);
      setRoutes(buildRoutes(menus));
      return;
    }
    const menus = getMenus(agencyDetailProps?.data?.status, user?.active_account_role);
    setMenusList(menus);
    setRoutes(buildRoutes(menus));
  }, [user?.active_account_type, agencyDetailProps?.data?.status, user?.active_account_role]);

  return {
    menus: menusList,
    routes,
  };
};
